// Format taka price
export const formatPrice = (amount) =>
  `৳${Number(amount).toLocaleString('en-BD')}`;

// Discount calc
export const calcDiscount = (price, discountPrice) =>
  Math.round(((price - discountPrice) / price) * 100);

// Order status helpers
export const ORDER_STATUS_COLORS = {
  pending:    { bg: '#fef3c7', color: '#92400e', label: 'Pending' },
  confirmed:  { bg: '#dbeafe', color: '#1e40af', label: 'Confirmed' },
  processing: { bg: '#e0e7ff', color: '#3730a3', label: 'Processing' },
  shipped:    { bg: '#d1fae5', color: '#065f46', label: 'Shipped' },
  delivered:  { bg: '#dcfce7', color: '#166534', label: 'Delivered' },
  cancelled:  { bg: '#fee2e2', color: '#991b1b', label: 'Cancelled' },
  returned:   { bg: '#f3f4f6', color: '#374151', label: 'Returned' },
};

// Bangladesh divisions
export const BD_DIVISIONS = [
  'Dhaka', 'Chittagong', 'Rajshahi', 'Khulna',
  'Barisal', 'Sylhet', 'Rangpur', 'Mymensingh',
];

// Bangladesh districts
export const BD_DISTRICTS = {
  Dhaka: ['Dhaka', 'Gazipur', 'Narayanganj', 'Manikganj', 'Munshiganj', 'Narsingdi', 'Tangail', 'Kishoreganj', 'Faridpur', 'Gopalganj', 'Madaripur', 'Rajbari', 'Shariatpur'],
  Chittagong: ['Chittagong', 'Cox\'s Bazar', "Comilla", 'Noakhali', 'Feni', 'Chandpur', 'Lakshmipur', 'Brahmanbaria'],
  Rajshahi: ['Rajshahi', 'Bogra', 'Naogaon', 'Natore', 'Chapai Nawabganj', 'Pabna', 'Sirajganj', 'Joypurhat'],
  Khulna: ['Khulna', 'Bagerhat', 'Satkhira', 'Jessore', 'Narail', 'Magura', 'Jhenaidah', 'Kushtia', 'Meherpur', 'Chuadanga'],
  Barisal: ['Barisal', 'Bhola', 'Jhalokathi', 'Patuakhali', 'Pirojpur', 'Barguna'],
  Sylhet: ['Sylhet', 'Habiganj', 'Moulvibazar', 'Sunamganj'],
  Rangpur: ['Rangpur', 'Dinajpur', 'Gaibandha', 'Kurigram', 'Lalmonirhat', 'Nilphamari', 'Panchagarh', 'Thakurgaon'],
  Mymensingh: ['Mymensingh', 'Jamalpur', 'Netrokona', 'Sherpur'],
};

// Payment methods
export const PAYMENT_METHODS = [
  { id: 'bkash',      label: 'bKash',       icon: '📱', color: '#E2136E' },
  { id: 'nagad',      label: 'Nagad',       icon: '💰', color: '#F6821F' },
  { id: 'rocket',     label: 'Rocket',      icon: '🚀', color: '#8B5CF6' },
  { id: 'sslcommerz', label: 'Card/Net',    icon: '💳', color: '#2563EB' },
  { id: 'cod',        label: 'Cash on Delivery', icon: '💵', color: '#16A34A' },
];

// Date format
export const formatDate = (dateStr) => {
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-BD', { year: 'numeric', month: 'short', day: 'numeric' });
};

// Truncate text
export const truncate = (str, n = 60) =>
  str?.length > n ? str.substring(0, n) + '…' : str;
